// extracted by mini-css-extract-plugin
export default {"loading":"index__loading___2bIl0","image":"index__image___2tPuf"};